import { render } from "./PoolPanels.vue?vue&type=template&id=a898aff2&scoped=true"
import script from "./PoolPanels.vue?vue&type=script&lang=js"
export * from "./PoolPanels.vue?vue&type=script&lang=js"

import "@/Common/Styles/poolPanels.scss?vue&type=style&index=0&id=a898aff2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a898aff2"]])

export default __exports__